import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { OutPostModalService } from "./out-post-modal.service";
import { AvatarModule } from "ngx-avatars";
import { CommonModule } from "@angular/common";
import { SpinnerComponent2 } from "../../spinners/spinner2.component";
import { API_URLS } from "../../../config/app.constants";
import { HttpinterceptorService } from "../../services/httpinterceptor.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
declare var $: any;

@Component({
  selector: "app-outpost-list-modal",
  templateUrl: "./outpost-list-modal.component.html",
  styleUrls: ["./outpost-list-modal.component.scss"],
  standalone: true,
  imports: [SpinnerComponent2, CommonModule, AvatarModule],
})
export class OutpostListModalComponent implements OnInit {
  @Input() set fromParent(value: any) {
    if (Object.keys(value).length) {
      this.apiDataparams = value.data;
      this.getCurrentLocation();
    }
  }
  @Output() closeOutpostModal = new EventEmitter();
  lat;
  long;
  outpostList = [];
  apiDataparams: any;
  selectedOutpostId;
  isSpinner: boolean = false;

  constructor(
    private http: HttpinterceptorService,
    private outpostModalService: OutPostModalService,
    public activeModal: NgbActiveModal
  ) {}
  ngOnInit() {}
  getOutpostList() {
    this.isSpinner = true;
    const queryParmams: any = {
      lat: this.lat,
      long: this.long,
      service_type: this.apiDataparams.service_type,
      service_id: this.apiDataparams.service_id,
      out_post_id: this.apiDataparams.out_post_id,
    };
    this.http.post(API_URLS.GET_OUT_POST_LIST, queryParmams, false).subscribe(
      (res) => {
        this.outpostList = res.data.data;
        this.isSpinner = false;

        for (const outpost in this.outpostList) {
          const title = this.outpostList[outpost].title.split(" ");
          if (title.length == 1) {
            this.outpostList[outpost].icon = title
              .toString()
              .substring(0, 2)
              .toUpperCase();
          } else {
            const splitTitle = title[0] + " " + title[title.length - 1];
            const matches = splitTitle.match(/\b(\w)/g);
            this.outpostList[outpost].icon = matches.join("").toUpperCase();
          }
          this.outpostList[outpost].distance = Math.round(
            this.outpostList[outpost].distance
          );
        }
      },
      (error) => {
        this.isSpinner = false;
      }
    );
  }
  getCurrentLocation() {
    this.lat = localStorage.getItem("lat");
    this.long = localStorage.getItem("long");
    this.getOutpostList();
  }
  selectCenter(outpostData) {
    this.closeOutpostModal.emit(outpostData);
    this.activeModal.close();
    this.outpostModalService.currentOutpost(outpostData);
  }
  closeModal() {
    this.activeModal.close();
    this.closeOutpostModal.emit(false);
  }
}
